import { Endpoint, SignInitRequest, SignInitResponse } from '../class/class';
import { Constants, SigningMethod } from '../enums/const-enums';
import { noSignInit, signInit } from '../redux/actions/config-actions';
import {
  setActiveMethod,
  setPreferredMethod,
} from '../redux/actions/method-action';
import { initialStore } from '../redux/store';
import {
  getCookieValue,
  handleErrorResponse,
  handleMethodAndChallengeData,
  httpRequest,
  isMobileScreen,
  logd,
  postMessageToParent,
} from '../utils/utils';

export class SignInit extends Endpoint {
  static endpoint = 'qsl_sign_init';

  constructor() {
    super();
  }

  async doSignInit(): Promise<void> {
    if (this.isEotpPreferredOverSignInit) {
      initialStore.dispatch(setActiveMethod(SigningMethod.EOTP));
      initialStore.dispatch(noSignInit());
      return;
    }

    try {
      const req = SignInit.signInitRequest;
      logd(() =>
        console.log('%c doSignInit -> %c', 'color:#F60', 'color:#000', req),
      );
      const resp = await httpRequest<SignInitResponse>(
        `${this.baseUrl}${SignInit.endpoint}`,
        req,
      );
      postMessageToParent<AppModel.SignStatusEvent>({
        type: 'sign-status',
        value: 'initialized',
      });
      const signInitResponse = new SignInitResponse(resp.json);
      handleMethodAndChallengeData(signInitResponse);
      initialStore.dispatch(signInit(signInitResponse));
      return;
    } catch (error) {
      postMessageToParent<AppModel.SignStatusEvent>({
        type: 'sign-status',
        value: 'initialized',
      });
      handleErrorResponse(error as AppModel.HttpResponseErrorJson);
      initialStore.dispatch(noSignInit());
    }
  }
  private static get signInitRequest(): SignInitRequest {
    const state = initialStore.getState();
    if (this.isRaboScannerPreferredOverQr) {
      initialStore.dispatch(setPreferredMethod(SigningMethod.RABO_SCANNER));
    }
    return new SignInitRequest(
      state.methods.allowedSignMethods,
      state.methods.preferredSignMethod,
      state.config.absPath,
    );
  }

  private get isEotpPreferredOverSignInit(): boolean {
    const state = initialStore.getState();
    const isEotpPreferred =
      SigningMethod.EOTP.toLowerCase() ===
        getCookieValue(Constants.METHOD_COOKIE_NAME) ||
      state.methods.preferredSignMethod === SigningMethod.EOTP;
    return (
      isEotpPreferred &&
      state.config.isLoading &&
      state.methods.allowedSignMethods.includes(SigningMethod.EOTP)
    );
  }

  private static get isRaboScannerPreferredOverQr(): boolean {
    const state = initialStore.getState();
    return (
      isMobileScreen() &&
      state.methods.preferredSignMethod === SigningMethod.QR &&
      state.methods.allowedSignMethods.includes(SigningMethod.RABO_SCANNER)
    );
  }
}
